module.exports = __webpack_public_path__ + "static/media/back_theme2.a3b3c1e1.svg";